
import { MOCK_DATES, MOCK_USER } from './shared.mock';

export const tcpaDetailsMock = {
  'needs-consent': {
    hasConsented: false,
    consentDate: null,
    phones: [
      {
        phoneId: 'phone-1',
        phoneNumber: MOCK_USER.phone,
        phoneType: 'Mobile',
        isConsentGiven: false,
        consentDate: null,
        canReceiveCalls: false,
        canReceiveTexts: false,
      },
    ],
    disclosureText:
      'By providing consent, you agree to receive automated calls and text messages from loanDepot regarding your loan account.',
  },

  'already-consented': {
    hasConsented: true,
    consentDate: MOCK_DATES.paymentDate(90),
    phones: [
      {
        phoneId: 'phone-1',
        phoneNumber: MOCK_USER.phone,
        phoneType: 'Mobile',
        isConsentGiven: true,
        consentDate: MOCK_DATES.paymentDate(90),
        canReceiveCalls: true,
        canReceiveTexts: true,
      },
    ],
    disclosureText: '',
  },

  declined: {
    hasConsented: false,
    consentDate: null,
    declinedDate: MOCK_DATES.paymentDate(30),
    phones: [
      {
        phoneId: 'phone-1',
        phoneNumber: MOCK_USER.phone,
        phoneType: 'Mobile',
        isConsentGiven: false,
        consentDate: null,
        canReceiveCalls: false,
        canReceiveTexts: false,
      },
    ],
    disclosureText: 'You previously declined consent. You can update your preferences at any time.',
  },
};

export const updateTcpaConsentMock = {
  success: {
    isSuccess: true,
    message: 'Consent preferences updated successfully.',
  },
  error: {
    isSuccess: false,
    message: 'Failed to update consent preferences. Please try again.',
  },
};

export const paperlessStatusMock = {
  enrolled: {
    isEnrolled: true,
    enrollmentDate: MOCK_DATES.paymentDate(180),
    email: MOCK_USER.email,
  },
  'not-enrolled': {
    isEnrolled: false,
    enrollmentDate: null,
    email: MOCK_USER.email,
  },
};

export const updateLoanPaperlessSettingsMock = {
  success: {
    isSuccess: true,
    message: 'Paperless preferences updated successfully.',
  },
  error: {
    isSuccess: false,
    message: 'Failed to update paperless preferences.',
  },
};

export const payoffQuoteMock = {
  success: {
    isSuccess: true,
    requestId: `PAYOFF-${Date.now()}`,
    message: 'Your payoff quote request has been submitted. You will receive it within 3-5 business days.',
    estimatedDelivery: MOCK_DATES.futureDate(5),
  },
  'already-requested': {
    isSuccess: false,
    message: 'A payoff quote request is already pending for this loan.',
  },
  error: {
    isSuccess: false,
    message: 'Unable to submit payoff quote request. Please try again.',
  },
};
